module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "start-page"
    }
  }, [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isConnected),
      expression: "isConnected"
    }],
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content is-large"
  }, _vm._l((_vm.startInstruction), function(line) {
    return _c('p', [_vm._v(_vm._s(line))])
  })), _c('button', {
    staticClass: "button is-large is-primary",
    attrs: {
      "disabled": !_vm.isCalibrated
    },
    on: {
      "click": _vm.start
    }
  }, [_vm._v(_vm._s(_vm.tokens['start']))]), _c('button', {
    staticClass: "button is-large",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.tokens['cancel']))])])]), _c('div', {
    ref: "fullscreen",
    staticClass: "fullscreen"
  }, [(_vm.isRunning) ? _c('task-page', {
    attrs: {
      "texts": _vm.texts,
      "task": _vm.task,
      "student": _vm.student,
      "finilize": _vm.finilizeTask
    },
    on: {
      "finished": _vm.finishedReading,
      "saved": _vm.gazeDataSaved
    }
  }) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isFullscreen && !_vm.isRunning),
      expression: "isFullscreen && !isRunning"
    }],
    staticClass: "container tracking-lost-error-container"
  }, [_c('div', {
    staticClass: "message is-danger tracking-lost-error"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v(_vm._s(_vm.tokens['msg_tracking_lost']))])])])], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isCalibrated),
      expression: "!isCalibrated"
    }],
    staticClass: "container"
  }, [_c('div', {
    staticClass: "message is-danger"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v(_vm._s(_vm.tokens['msg_tracker_not_calibrated']))])]), _c('article', {
    staticClass: "message is-info"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v(_vm._s(_vm.tokens['msg_calib_window_not_visible']))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e5a70c2"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/task/StartPage.vue
// module id = 433
// module chunks = 0